import { render, staticRenderFns } from "./lastInvite.vue?vue&type=template&id=1a6a0f72&"
import script from "./lastInvite.vue?vue&type=script&lang=js&"
export * from "./lastInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports